import _ from 'lodash';
import { PubnubChannel } from './PubnubChannel';

/**
 * Handle common Pubnub actions controllers car about including:
 * broadcasting and waiting for a reload command, get occupancy count
 */
export class PubnubService {
	/**
	 * @param {Object} $state
	 * @param {Object} $rootScope
	 * @param {import('../identity/IdentityService').IdentityService} Identity
	 */
	constructor($state, $rootScope, Identity) {
		'ngInject';
		/**
		 * The UI Router state
		 * @type {Object}
		 */
		this.$state = $state;
		/**
		 * A registry of PubnubChannel objects by channel name
		 * @type {Object}
		 */
		this.channels = {};

		this.Identity = Identity;

		// unsubscribe from all channels on navigation
		$rootScope = $rootScope;
		$rootScope.$on('$stateChangeStart', () => {
			_.forOwn(this.channels, channel => channel.destroy());
			this.channels = {};
		});
	}

	/**
	 * Automatically reload this ui-router route when the reload signal is received
	 * @param {String} channelName  The name of the applicable channel
	 */
	awaitReload(channelName) {
		this.awaitAction(channelName, 'reload', () => this.$state.reload());
	}

	/**
	 * Broadcast the reload command to any other browsers listening to this channel
	 * @param {String} channelName
	 */
	triggerReload(channelName) {
		this.triggerAction(channelName, 'reload');
	}

	/**
	 * Call the given callback when the given action is broadcast
	 * @param {String} channelName
	 * @param {String} action
	 * @param {Function} callback
	 * @returns {PubnubChannel}
	 */
	awaitAction(channelName, action, callback) {
		return this.getChannel(channelName).subscribe(msg => {
			if (msg.action == action) {
				callback(msg);
			}
		});
	}

	/**
	 * Broadcast to all subscribers the given action and data
	 * @param {String} channelName
	 * @param {String} action
	 * @param {Object} data
	 * @returns {Promise}  Resolved when PubNub API has completed broadcast
	 */
	triggerAction(channelName, action, data = {}) {
		return this.getChannel(channelName).publish(_.extend({ action }, data));
	}

	/**
	 * Get the occupancy number for then given channel
	 * @param {String} channelName
	 * @returns {Promise<Number>}  A Promise that resolves to the number of people
	 */
	getOccupancy(channelName) {
		return this.getChannel(channelName).occupancy();
	}

	/**
	 * Get the PubnubChannel object for the given channel
	 * @param {String} channelName
	 * @returns {PubnubChannel}
	 */
	getChannel(channelName) {
		if (!this.channels[channelName]) {
			this.channels[channelName] = new PubnubChannel(channelName, this.Identity.user().uuid);
		}
		return this.channels[channelName];
	}
}
